var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140891",
    "data-name": "Group 140891",
    transform: "translate(-1268 -86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140890",
    "data-name": "Group 140890",
    transform: "translate(1268 86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    fill: "#dbe448",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-calendar",
    "data-name": "Icon metro-calendar",
    d: "M7.568,7.925h2v2h-2Zm3,0h2v2h-2Zm3,0h2v2h-2Zm-9,6h2v2h-2Zm3,0h2v2h-2Zm3,0h2v2h-2Zm-3-3h2v2h-2Zm3,0h2v2h-2Zm3,0h2v2h-2Zm-9,0h2v2h-2Zm10.994-9v1h-2v-1h-7v1h-2v-1h-2V17.92H17.563V1.928h-2Zm1,14.992H3.57V5.926H16.564Z",
    transform: "translate(1275.429 94.072)",
    fill: "#125bb2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.c48a7f1552c1d81b12716a2bf16305d1.svg";
export { ForwardRef as ReactComponent };